export default "__VITE_ASSET__Dgt$j3LG__"